/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Connect_Gallery_TitleInputs */



/**
* | output |
* | --- |
* | "Connector quick start" |
*
* @param {Preferences_Connect_Gallery_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_connect_gallery_title = /** @type {((inputs?: Preferences_Connect_Gallery_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Connect_Gallery_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Schnellstart für Konnektoren")
	return /** @type {LocalizedString} */ ("Connector quick start")
});